export const UserIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
         <path d="M7.00058 7C5.07033 7 3.50058 5.43025 3.50058 3.5C3.50058 1.56975 5.07033 0 7.00058 0C8.93083 0 10.5006 1.56975 10.5006 3.5C10.5006 5.43025 8.93083 7 7.00058 7ZM8.58375 8.41167L7.50867 10.0275L8.59367 14H11.6672C11.9898 14 12.2506 13.7387 12.2506 13.4167C12.2506 11.0734 10.7071 9.08483 8.58375 8.41167ZM6.49192 10.0275L5.41683 8.41167C3.2935 9.08483 1.75 11.0734 1.75 13.4167C1.75 13.7387 2.01133 14 2.33333 14H5.40692L6.49192 10.0275Z" fill="white"/>
        </svg>
    `,
      }}
    />
  );
};
